var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-2 text-center",attrs:{"outlined":"","tile":""}},[_vm._v("\n "+_vm._s(_vm.Articulo[0].Stock)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }